// extracted by mini-css-extract-plugin
export default {"folderBreadcrumbs":"Audio_folderBreadcrumbs__Cxp+E"};